import React from "react";

const DirectoryConnectionError = ({errorMessage, actionText}) => (
  <div className="text-center">
    {errorMessage}
    <div>{actionText}</div>
  </div>
);

export default DirectoryConnectionError;